import { useMemo } from 'react'
import { BigNumber } from '@ethersproject/bignumber'
// import dateFormat from 'dateformat'
import { useLockFactoryContract } from '../hooks/useContract'
import { useSingleCallResult } from '../state/multicall/hooks'

export function useProjectList(owner?: string,): any {
  const contract = useLockFactoryContract(false)

  const inputs = useMemo(() => [owner], [owner])
  const tokenList = useSingleCallResult(contract, 'getUserMemeList', inputs).result
  const tokens = tokenList?.list || []
  const tokensView = tokens.map((item:any) => {
    return {
      amount: BigNumber.from(item.initialAmount.toString()).div(`${10 ** 18}`).toString(),
      symbol: item.symbol,
      tokenAddress: item.memeAddress,
      lockAdderss: item.lockAdderss,
    }
  })

  const tokenSort = tokensView.sort((a,b)=>{ return b.timeStr - a.timeStr})
  return tokenSort
}

export default useProjectList
